import {HttpClient} from "../../service/httpClient/HttpClient";

export class ProjectService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getProjectsList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-projects`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getProjectDetail(projectId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-projects/${projectId}`,
            ).then(resolve).catch(reject)
        })
    }

    updateProjectInfo(id, title, writerName, photoId, shortDescription, description, enabled) {
        return new Promise((resolve, reject) => {
            this.doUpdateProject(
                id,
                title,
                writerName,
                photoId,
                shortDescription,
                description,
                enabled
            ).then(resolve).catch(reject)
        })
    }

    doUpdateProject(id, title, writerName, photoId, shortDescription, description, enabled) {
        return this.httpClient.put(
            `site-projects/${id}`,
            {
                "title": title,
                "shortDescription": shortDescription,
                "authorInformation": writerName,
                "thumbnailId": photoId,
                "contents": prepareBlogDescription(description)
            }
        )
    }

    addNewProject(title, writerName, photoId, shortDescription, description) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `site-projects`,
                {
                    "title": title,
                    "shortDescription": shortDescription,
                    "authorInformation": writerName,
                    "thumbnailId": photoId,
                    "contents": prepareBlogDescription(description)
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteProject(projectId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `site-projects/${projectId}`,
            ).then(resolve).catch(reject)
        })
    }
}

export function prepareBlogDescription(description) {
    const _description = []
    description.map((item, index) => {
        _description.push(
            {
                "content": item.content,
                "priority": index
            }
        )
    })

    return _description
}